import React, { useEffect, useState } from 'react';
import { Divider } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Skeleton } from '@material-ui/lab';
import Checkbox from '@material-ui/core/Checkbox';
import APIExtensionsV2 from "../../yoello-lib/modules/API2/APIDefs";
import IVenueSettings from '../../interfaces/IVenueSettings';
import { useTranslation } from 'react-i18next';
import { OrderTypes, filtersObject, FilterItemsInitialState } from "./constants"
import TableAreas from "./TableAreas"
import Styles from "../../scss/orderHistory.module.scss";
import { IDialogChildComponent } from '../../reducers/dialog';
import { useAPIV2 } from '../../yoello-lib/modules/API2/useAPIv2';
interface IFiltersProps extends IDialogChildComponent {
    onApplyFiltersAndSearch: (orderTypes: filtersObject, areas: filtersObject, filtersCount: number, filtersChanged: boolean) => void;
    // resetFilters: () => void;
    setOpenFiltersModal: (open: boolean) => void;
    selectedFitersCount: number;
    filterItems: filtersObject;
    tableAreas: filtersObject;
    venueId: string
}
function Filters({
    selectedFitersCount,
    setOpenFiltersModal,
    filterItems,
    venueId,
    onApplyFiltersAndSearch,
    tableAreas,
    onClose
    // resetFilters
}: IFiltersProps) {

    const [orderTypes, setOrderTypes] = useState<Record<string, boolean>>(filterItems);
    const [areas, setAreas] = useState<Record<string, boolean>>(tableAreas);
    const [filtersCount, setFiltersCount] = useState<number>(selectedFitersCount);
    const { apiData: venueData, isLoading: isVenueDataLoading } = useAPIV2<IVenueSettings>(APIExtensionsV2.venueSettings, { query: venueId, });

    console.log('venueData', venueData)

    const { t } = useTranslation();
    useEffect(() => {
        const filters: Record<string, boolean> | undefined = {}
        if (venueData && venueData.table_layout) {
            venueData.table_layout.forEach(area => {
                if (areas[area.table_range_name]) {
                    filters[area.table_range_name] = true
                }
                else { filters[area.table_range_name] = false }
            })
        }
        if (filters) setAreas({ ...areas, ...filters });
        // eslint-disable-next-line 
    }, [venueData]);
    function onFiltersChange(event: React.ChangeEvent<HTMLInputElement>) {
        setOrderTypes({ ...orderTypes, [event.target.name]: event.target.checked });
        if (event.target.checked) {
            setFiltersCount(preveState => ++preveState);
        } else {
            if (event.target.name === OrderTypes.TABLE_DELIVERY) {
                let count = 0;
                let newAreas: Record<string, boolean> = {};
                Object.keys(areas).forEach(function (key) {
                    if (areas[key]) { newAreas[key] = false; };
                })
                if (orderTypes.HOME_DELIVERY) { count++ };
                if (orderTypes.COLLECTION) { count++ };
                setFiltersCount(count);
                setAreas(newAreas);
                setOrderTypes({ ...orderTypes, [event.target.name]: event.target.checked });
            }
            else setFiltersCount(preveState => --preveState);
        }
    };
    function onTableAreasChange(event: React.ChangeEvent<HTMLInputElement>) {
        setAreas({ ...areas, [event.target.name]: event.target.checked });
        if (event.target.checked) {
            setFiltersCount(preveState => ++preveState);
        }
        else setFiltersCount(preveState => --preveState);
    };
    function renderTableAreas() {
        if (isVenueDataLoading) {
            return <Skeleton />
        }
        else if (venueData && venueData.table_layout) {
            return venueData.table_layout.map((area) => <TableAreas
                filterItems={orderTypes}
                tableAreas={areas}
                areaName={area.table_range_name}
                onFiltersChange={onTableAreasChange}
                key={area.table_range_name}
            />
            )
        }
        else {
            return null;
        }

    }
    function onApplyFilters() {
        onApplyFiltersAndSearch(orderTypes, areas, filtersCount, true);
        close();
    }
    function close() {
        if (setOpenFiltersModal) {
            setOpenFiltersModal(false);
        } else {
            onClose()
        }
    }
    function clearFilters() {
        setOrderTypes(FilterItemsInitialState);
        setAreas({});
        setFiltersCount(0);
        onApplyFiltersAndSearch(FilterItemsInitialState, {}, 0, true);
    }
    return (
        <div className={Styles.FiltersContainer}>
            <header>
                <div>
                    <p>{t("orderHistory.filters.title")}</p>
                    <button onClick={clearFilters}>{t("orderHistory.filters.clear")}</button>
                </div>
            </header>
            <Divider />
            <div className={Styles.filterOptions}>
                <div className={Styles.OrderTypesSection}>
                    <p>{t("orderHistory.filters.orderTypes")}</p>
                    <div>
                        <FormControlLabel
                            control={<Checkbox
                                checked={orderTypes.TABLE_DELIVERY}
                                onChange={onFiltersChange}
                                name={OrderTypes.TABLE_DELIVERY}
                                color="primary"
                            />}
                            label={t("orderHistory.filters.dineIn")}
                            className={Styles.filtersCheckboxes}
                        />
                        <FormControlLabel
                            control={<Checkbox
                                checked={orderTypes.HOME_DELIVERY}
                                onChange={onFiltersChange}
                                name={OrderTypes.HOME_DELIVERY}
                                color="primary"
                            />}
                            label={t("orderHistory.filters.homeDelivery")}
                            className={Styles.filtersCheckboxes}
                        />
                        <FormControlLabel
                            control={<Checkbox
                                checked={orderTypes.COLLECTION}
                                onChange={onFiltersChange}
                                name={OrderTypes.COLLECTION}
                                color="primary"
                            />}
                            label={t("orderHistory.filters.collection")}
                            className={Styles.filtersCheckboxes}
                        />
                    </div>
                </div>
                <Divider />
                <div className={Styles.TableVenueAreasSection}>
                    <p>{t("orderHistory.filters.table")}</p>
                    <div>
                        {renderTableAreas()}
                    </div>
                </div>
            </div>
            <div className={Styles.controllers}>
                <button onClick={() => {
                    close();
                }}>{t('forms.buttons.cancel')}</button>
                <button onClick={onApplyFilters}>{t('forms.buttons.applyfilters')}</button>
            </div>
        </div>
    )
}

export default Filters
